import React, { memo, useCallback } from 'react'
import {
  Modal,
  Button,
  Checkbox,
  Tooltip,
  Divider,
  Typography,
  Space,
} from 'antd'
import {
  FileTextFilled,
  InfoCircleOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
} from '@ant-design/icons'
import { SIGNER_TYPES } from './constant'

const { Paragraph, Text } = Typography

// Định nghĩa các style dùng chung
const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 0',
}

const iconStyle = {
  color: '#1890ff',
  fontSize: '20px',
}

const titleTextStyle = {
  fontSize: '20px',
  fontWeight: 500,
}

const infoBoxStyle = {
  backgroundColor: '#e6f7ff',
  padding: '16px',
  borderRadius: '8px',
  marginBottom: '24px',
  borderLeft: '4px solid #1890ff',
  display: 'flex',
  alignItems: 'flex-start',
}

const optionContainerStyle = {
  backgroundColor: '#f9f9f9',
  padding: '16px',
  borderRadius: '8px',
  border: '1px solid #e8e8e8',
  marginBottom: '16px',
}

// Component cho từng tùy chọn checkbox
const OptionCheckbox = ({ label, tooltipText, value, ...rest }) => (
  <div style={optionContainerStyle}>
    <Checkbox value={value} style={{ width: '100%' }} {...rest}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Tooltip
          title={tooltipText}
          style={{ fontWeight: 500, fontSize: '14px' }}>
          {label}
        </Tooltip>
      </div>
    </Checkbox>
  </div>
)

// Component Modal chính
const SignModal = ({
  isModalVisible,
  setIsModalVisible,
  displaySignChecked,
  setDisplaySignChecked,
  otherCheckboxValues,
  setOtherCheckboxValues,
  handleSign,
  combinedValues,
}) => {
  const handleCancel = useCallback(() => {
    setIsModalVisible(false)
    setDisplaySignChecked(false)
    setOtherCheckboxValues([])
  }, [setIsModalVisible, setDisplaySignChecked, setOtherCheckboxValues])

  return (
    <Modal
      title={
        <div style={headerStyle}>
          <FileTextFilled style={iconStyle} />
          <span style={titleTextStyle}>Xác nhận ký tài liệu</span>
        </div>
      }
      visible={isModalVisible}
      onCancel={handleCancel}
      width={500}
      centered
      footer={null}
      bodyStyle={{ padding: '24px' }}
      style={{ top: 20 }}>
      {/* Info Box */}
      <div style={infoBoxStyle}>
        <InfoCircleOutlined
          style={{
            color: '#1890ff',
            fontSize: '16px',
            marginTop: '2px',
            marginRight: '12px',
          }}
        />
        <Paragraph style={{ color: '#0050b3', margin: 0 }}>
          Vui lòng xác nhận các tùy chọn hiển thị trước khi ký tài liệu này.
        </Paragraph>
      </div>

      {/* Tùy chọn hiển thị */}
      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 600,
            marginBottom: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Text strong>Tùy chọn hiển thị</Text>
          <Tooltip title="Hiển thị dấu mộc khi ký tài liệu">
            <InfoCircleOutlined style={{ color: '#bfbfbf' }} />
          </Tooltip>
        </div>
        <div style={optionContainerStyle}>
          <Checkbox
            checked={displaySignChecked}
            onChange={e => setDisplaySignChecked(e.target.checked)}
            style={{ fontSize: '14px' }}>
            <Space>
              <span style={{ fontWeight: 500 }}>Hiển thị dấu mộc</span>
              <Tooltip title="Khi được chọn, chữ ký sẽ bao gồm dấu mộc của đơn vị">
                <InfoCircleOutlined style={{ color: '#bfbfbf' }} />
              </Tooltip>
            </Space>
          </Checkbox>
        </div>
      </div>

      <Divider style={{ margin: '24px 0' }} />

      {/* Thông tin hiển thị khi ký */}
      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 600,
            marginBottom: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Text strong>Thông tin hiển thị khi ký</Text>
          <Tooltip title="Chọn thông tin sẽ hiển thị cùng với chữ ký của bạn">
            <InfoCircleOutlined style={{ color: '#bfbfbf' }} />
          </Tooltip>
        </div>

        <Checkbox.Group
          value={otherCheckboxValues}
          onChange={setOtherCheckboxValues}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}>
          <OptionCheckbox
            label="Cơ quan"
            tooltipText="Hiển thị tên phòng ban/đơn vị của người ký"
            value={SIGNER_TYPES.signer}
          />
          <OptionCheckbox
            label="Thời gian ký"
            tooltipText="Hiển thị ngày giờ thực hiện ký tài liệu"
            value={SIGNER_TYPES.time}
          />
        </Checkbox.Group>
      </div>
      <Divider />
      {/* Nút hành động */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
        }}>
        <Button danger onClick={handleCancel}>
          Hủy ký
        </Button>
        <Button type="primary" onClick={() => handleSign(combinedValues)}>
          Xác nhận ký
        </Button>
      </div>
    </Modal>
  )
}

export default memo(SignModal)
